export const SendDisclosureModalActions = {
  AGREE: 'agree',
  REJECT: 'reject',
};

export const sendDisclosureModalActionToDelayHours = {
  [SendDisclosureModalActions.AGREE]: 0,
  [SendDisclosureModalActions.REJECT]: 48,
};

export const sendDisclosureModalActionToSuccessMessage = {
  [SendDisclosureModalActions.AGREE]: 'Bundle was successfully sent',
  [SendDisclosureModalActions.REJECT]: 'Bundle is scheduled to be sent in 48 hours',
};

export const SendDisclosureType = {
  INITIAL: 'initial',
  DELAYED: 'delayed',
};

export const RICH_TEXT_EDITOR_RELATED_FIELDS = ['PostClosingReason', 'SuspenseReason'];

export const LOAN_ACTION_RICH_TEXT_MAX_LENGTH = 500;

export const LOAN_ACTION_RICH_TEXT_MAX_LENGTH_ERROR = 'Field value is too long';

export const REASON_FIELD_NAME = 'reason';
export const REASON_MAX_LENGTH = 1000;
export const REASON_ROWS = 4;
export const REASON_INPUT_PROPS = { 'data-novalidate': true };
